import { MDCDataTable } from '@material/data-table'

export default {
  setup() {
    this.dataTable = new MDCDataTable(this.el)
  },
  destroy() {
    this.dataTable?.destroy()
    this.dataTable = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
